import React, { Component } from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from '../api';
import 'url-search-params-polyfill';
import '../styles/Footer.css';
import '../styles/Loader.css';

class ValidaVoto extends Component {
  state = {
    loading: true,
    status: 0
  } 

  componentDidMount = () => {
    const params = new URLSearchParams(window.location.search);  
    const token = params.get("token");
    this.validateVote(token);
  }

  validateVote = async token => {
    try {
      const response = await api.votes.validate(token);
      this.setState({status: response.status, loading: false})    
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return (
      <div>
        <Navbar />
        <Header />
        <div className="container">
           {this.state.loading && 
           <div className="col-lg-12 text-center">
             <div className="lds-ripple"><div></div><div></div></div>
             <div classsName="d-block">Verificando</div>
            </div>
            }
          <p className="lead">
            {this.state.status === 200 && 'Tu votación se ha validado con éxito. Gracias por participar.'}
            {this.state.status === 201 && 'Este token NO es válido.'}
            {this.state.status === 410 && 'Tu token ha expirado/el concurso ya terminó.'}
            {this.state.status === 500 && 'Ocurrió un error inesperado.'}
          </p>
        </div>
        <Footer />
        
      </div>
    );
  }
}

export default ValidaVoto;
